import { render, staticRenderFns } from "./tableUMR.vue?vue&type=template&id=90bc2dc8&scoped=true"
import script from "./tableUMR.vue?vue&type=script&lang=js"
export * from "./tableUMR.vue?vue&type=script&lang=js"
import style0 from "./tableUMR.vue?vue&type=style&index=0&id=90bc2dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc2dc8",
  null
  
)

export default component.exports